import { render, staticRenderFns } from "./show.vue?vue&type=template&id=1453c541&scoped=true&"
import script from "./show.ts?vue&type=script&lang=ts&"
export * from "./show.ts?vue&type=script&lang=ts&"
import style0 from "./show.vue?vue&type=style&index=0&id=1453c541&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1453c541",
  null
  
)

export default component.exports